import { FC, useMemo } from 'react';

import dayjs from 'dayjs';

import { useCurrentUserSeriesPlannerPlansQuery, useSeriesByTagSlug } from '@queries/TagQueries';

import { PrimaryCtaCard } from '@components/layout/PrimaryCtaCard/PrimaryCtaCard';

import prideSvgUrl from '@screens/entertainer/EntertainerDetailsScreen/assets/pride.svg';

export const PRIDE_WEEKEND_START_DATE = '2026-06-26';
export const PRIDE_WEEKEND_END_DATE = '2026-06-28';

interface DenverPride2026PrimaryCtaCardProps {
  className?: string;
  tagSlug: string;
  hideIfCompleted?: boolean;
}

export const DenverPride2026PrimaryCtaCard: FC<DenverPride2026PrimaryCtaCardProps> = ({
  className,
  tagSlug,
  hideIfCompleted,
}) => {
  const { series } = useSeriesByTagSlug(tagSlug);
  const isPrideWeekendOver = dayjs().isAfter(PRIDE_WEEKEND_END_DATE, 'day');

  const { seriesPlannerPlans } = useCurrentUserSeriesPlannerPlansQuery();

  const prideWeekendPlannerPlans = useMemo(() => {
    return seriesPlannerPlans?.[series?._id ?? '']?.find(
      (plan) =>
        plan.startDate === PRIDE_WEEKEND_START_DATE && plan.endDate === PRIDE_WEEKEND_END_DATE,
    );
  }, [seriesPlannerPlans, series?._id]);

  if (isPrideWeekendOver) {
    return null;
  }

  if (hideIfCompleted && prideWeekendPlannerPlans) {
    return null;
  }

  return (
    <div className={className}>
      <PrimaryCtaCard
        cta={{
          img: prideSvgUrl,
          title: 'Denver Pride Planner 2026',
          description: `Your quick start planner for sexy Denver Pride Weekend`,
          url: `/noauth/series/${tagSlug}/planner/${PRIDE_WEEKEND_START_DATE}/${PRIDE_WEEKEND_END_DATE}`,
          badgeCount:
            series?._id && seriesPlannerPlans && !prideWeekendPlannerPlans ? 1 : undefined,
        }}
        track={{ event: 'Click Denver Pride Planner CTA' }}
      />
    </div>
  );
};
